import RecipePagination from './RecipePagination';

export default RecipePagination;
